import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import { useAuth } from "@/hooks/useAuth";

const NotFound = () => {
  const location = useLocation();
  const { user, isLoading } = useAuth();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  // For non-authenticated users, render full-screen 404 without layout (rendered outside AppLayout)
  if (!isLoading && !user) {
    return (
      <div className="min-h-screen bg-gray-900 flex items-center justify-center overflow-hidden relative">
        {/* Large semi-transparent 404 background */}
        <div className="absolute inset-0 flex items-center justify-center">
          <h1 className="text-[20rem] font-bold text-gray-800/20 select-none pointer-events-none">
            404
          </h1>
        </div>
        
        {/* Content overlay */}
        <div className="relative z-10 text-center px-4">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            You're in uncharted growth territory!
          </h2>
          <p className="text-lg md:text-xl text-white/80 mb-8 max-w-2xl mx-auto">
            Looks like you took a wrong turn. But don't worry, even the best growth marketers get lost sometimes!
          </p>
          <Link 
            to="/home" 
            className="inline-block text-white underline hover:text-white/80 transition-colors text-lg"
          >
            Return home
          </Link>
        </div>
      </div>
    );
  }

  // For authenticated users, render within the layout
  return (
    <div className="min-h-[calc(100vh-4rem)] flex items-center justify-center bg-background relative overflow-hidden">
      {/* Large semi-transparent 404 background */}
      <div className="absolute inset-0 flex items-center justify-center">
        <h1 className="text-[15rem] md:text-[20rem] font-bold text-muted-foreground/10 select-none pointer-events-none">
          404
        </h1>
      </div>
      
      {/* Content overlay */}
      <div className="relative z-10 text-center px-4">
        <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4">
          You're in uncharted growth territory!
        </h2>
        <p className="text-base md:text-lg text-muted-foreground mb-8 max-w-2xl mx-auto">
          Looks like you took a wrong turn. But don't worry, even the best growth marketers get lost sometimes!
        </p>
        <Link 
          to="/dashboard" 
          className="inline-block text-primary underline hover:text-primary/80 transition-colors"
        >
          Return home
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
